/**
 * White content band on the blue canvas — keeps long-form pages readable.
 */
export default function RfPageFrame({ children, className = '' }) {
  return (
    <div className={`max-w-[1140px] mx-auto px-5 py-10 md:py-14 ${className}`}>{children}</div>
  );
}
